import React from 'react';
import PropTypes from 'prop-types';
import Styles from './styles';

const InspectorSection = props => (
  <div style={Styles.wrapper}>
    {!props.hideHeader && (
      <div style={Styles.header}>
        <span style={Styles.headerText}>{props.title}</span>
        <button style={Styles.resetButton} onClick={props.onResetClick}>
          <span className="icon-reset" />
        </button>
      </div>
    )}
    {props.children}
  </div>
);

InspectorSection.propTypes = {
  children: PropTypes.node,
  hideHeader: PropTypes.bool,
  title: PropTypes.string,
  onResetClick: PropTypes.func,
};

InspectorSection.defaultProps = {
  children: null,
  hideHeader: false,
  title: '',
  onResetClick: () => {},
};

export default InspectorSection;



// WEBPACK FOOTER //
// ./src/components/Inspector/InspectorSection/InspectorSection.js